import Dashboard from "../Components/Pages/MainPages/Dashboard/Index";
import Transactions from "../Components/Pages/MainPages/Transactions";
import Customers from "../Components/Pages/MainPages/Customers";
import Help from "../Components/Pages/MainPages/Help";
import Collections from "../Components/Pages/MainPages/Collections/Index";
import SubCollections from "../Components/Pages/MainPages/SubCollections/SubCollections";
import Store from "../Components/Pages/MainPages/Store/Store";
import Products from "../Components/Pages/MainPages/Products/Products";
import ProductDetails from "../Components/Pages/MainPages/Products/ProductDetails";
import Stocks from "../Components/Pages/MainPages/Stocks/Stocks";
import ViewStore from "../Components/Pages/MainPages/Store/view";
import Brands from "../Components/Pages/MainPages/Brands";
import CreateProduct from "../Components/Pages/MainPages/Products/create";
import Variants from "../Components/Pages/MainPages/Variants/Variants";
import Orders from "../Components/Pages/MainPages/Orders/Index";
import ErrorPage4 from "../Components/Pages/ErrorPages/ErrorPage404";
import ViewOrder from "../Components/Pages/MainPages/Orders/view";
import RoleManagement from "../Components/Pages/MainPages/RoleManagement";
import RoleForm from "../Components/Pages/MainPages/RoleManagement/RoleForm";
import Employees from "../Components/Pages/MainPages/Employees";
import Reports from "../Components/Pages/MainPages/Reports";
import ContentManagement from "../Components/Pages/MainPages/ContentManagement";
import Coupons from "../Components/Pages/MainPages/Coupons";
import InventoryLog from "../Components/Pages/MainPages/Stocks/InventoryLog";
import CustomerDetailPage from "../Components/Pages/MainPages/Customers/CustomerDetailPage";
import LoyaltySettings from "../Components/Pages/MainPages/Loyality/Loyalty";
import VariantSalesHistory from "../Components/Pages/MainPages/Stocks/VariantSalesHistory";
import LoyaltyTable from "../Components/Pages/MainPages/Loyality/LoyaltyTable";
import LoyaltyHistoryPage from "../Components/Pages/MainPages/Loyality/LoyaltyHistory";
import SpecialTable from "../Components/Pages/MainPages/Special/SpecialTable";
import CreateSpecial from "../Components/Pages/MainPages/Special/CreateSpecial";
import TagManagement from "../Components/Pages/MainPages/Customers/Tag/index";
import ApplyTagsPage from "../Components/Pages/MainPages/Customers/ApplyTags/index";
import Blog from '../Components/Pages/MainPages/Blog/Index';
import BlogCreate from "../Components/Pages/MainPages/Blog/BlogCreate";
import BlogEdit from "../Components/Pages/MainPages/Blog/BlogEdit";
import BlogDashboard from "../Components/Pages/MainPages/Blog/BlogDashboard";
import BlogDetail from "../Components/Pages/MainPages/Blog/BlogDetails";
import CategoryManagement from "../Components/Pages/MainPages/Blog/CategoryManagement";
import PendingComments from "../Components/Pages/MainPages/Blog/PendingComments";
import EmailMarketingDashboard from "../Components/Pages/MainPages/EmailMarketing/EmailMarketingDashboard";
import BoostCampaignManager from "../Components/Pages/MainPages/Loyality/BoostCampaignManager.jsx";
import CampaignDetailsPage from "../Components/Pages/MainPages/Loyality/CampaignDetailsPage";
import CouponUsageAnalytics from "../Components/Pages/MainPages/Coupons/CouponUsageAnalytics.jsx";
import Notice from '../Components/Pages/MainPages/Notice/index.jsx';
import FAQManagement from '../Components/Pages/MainPages/BusinessSettings/FAQ/index.jsx';
import ReturnPolicy from '../Components/Pages/MainPages/BusinessSettings/ReturnPolicy/index.jsx';
import PrivacyPolicy from '../Components/Pages/MainPages/BusinessSettings/PrivacyPolicy/index.jsx';
import TermsAndConditions from '../Components/Pages/MainPages/BusinessSettings/TermsAndConditions/index.jsx';
import AboutUs from '../Components/Pages/MainPages/BusinessSettings/AboutUs/index.jsx';
import ContactUsEditor from '../Components/Pages/MainPages/BusinessSettings/ContactUs/index.jsx';
import AnnouncementManagement from '../Components/Pages/MainPages/BusinessSettings/Announcements/index.jsx';
import StoreRevenue from "../Components/Pages/MainPages/Store/view/Revenue.jsx";
import ActivityLog from "../Components/Pages/MainPages/ActivityLog/index.jsx";
import RequirePermission from "../Components/RequirePermission";
import StockTransfers from "../Components/Pages/MainPages/Stocks/StockTransfers.jsx";
import DeliveryPartners from "../Components/Pages/MainPages/DeliveryPartner/index.jsx";
import Business from "../Components/Pages/MainPages/Business/index.jsx";
import LandingContentManager from "../Components/Pages/MainPages/Business/LandingContentManager.jsx";
import B2BAddressApproval from "../Components/Pages/MainPages/Business/B2BAddressApproval.jsx";
import GPReports from "../Components/Pages/MainPages/GPReports/GPReports.jsx";
import AppVersionManager from "../Components/Pages/MainPages/AppVersion";
import CustomerRewardsTable from "../Components/Pages/MainPages/Reward";
import RewardSettingsTable from "../Components/Pages/MainPages/Reward/RewardSettingsTable.jsx";
import SeoStaticPages from "../Components/Pages/MainPages/Seo";

// Inventory Management (feature/inventory_management)
import StoreManagement from "../Components/Pages/MainPages/Inventory/StoreManagement";
import StoreForm from "../Components/Pages/MainPages/Inventory/StoreForm";
import InventoryStoreDetails from "../Components/Pages/MainPages/Inventory/StoreDetails";
import SupplierManagement from "../Components/Pages/MainPages/Inventory/SupplierManagement";
import SupplierForm from "../Components/Pages/MainPages/Inventory/SupplierForm";
import SupplierDetails from "../Components/Pages/MainPages/Inventory/SupplierDetails";
import PurchaseOrders from "../Components/Pages/MainPages/Inventory/PurchaseOrders";
import PurchaseOrderForm from "../Components/Pages/MainPages/Inventory/PurchaseOrderForm";
import PurchaseOrderDetails from "../Components/Pages/MainPages/Inventory/PurchaseOrderDetails";
import StockReceiptForm from "../Components/Pages/MainPages/Inventory/StockReceiptForm";
import ReturnToSupplier from "../Components/Pages/MainPages/Inventory/ReturnToSupplier";
import ReturnToSupplierForm from "../Components/Pages/MainPages/Inventory/ReturnToSupplierForm";
import ReturnToSupplierDetails from "../Components/Pages/MainPages/Inventory/ReturnToSupplierDetails";
import Stocktake from "../Components/Pages/MainPages/Inventory/Stocktake";
import StocktakeForm from "../Components/Pages/MainPages/Inventory/StocktakeForm";
import StocktakeSession from "../Components/Pages/MainPages/Inventory/StocktakeSession";
import StocktakeDetails from "../Components/Pages/MainPages/Inventory/StocktakeDetails";
import BulkUpload from "../Components/Pages/MainPages/Inventory/BulkUpload";
import StockAdjustments from "../Components/Pages/MainPages/Inventory/StockAdjustments";
import MovementLog from "../Components/Pages/MainPages/Inventory/MovementLog";
import InventoryReporting from "../Components/Pages/MainPages/Inventory/InventoryReporting";
import GroupTags from "../Components/Pages/MainPages/GroupTag";
import FlashDeal from "../Components/Pages/MainPages/FlashDeal/FlashDealTable.jsx";
import FlashDealCreate from "../Components/Pages/MainPages/FlashDeal/CreateFlashDeal.jsx";
import ViewFlashDeal from "../Components/Pages/MainPages/FlashDeal/ViewFlashDeal.jsx";
import DeliveryZoneRequests from "../Components/Pages/MainPages/DeliveryZoneRequests";

const guard = (codes, element) => (
  <RequirePermission codes={codes}>{element}</RequirePermission>
);

let routes = [
  { path: `/dashboard`, Component: guard("dashboard.view", <Dashboard />) },
  { path: `/transactions`, Component: guard("orders.list", <Transactions />) },
  { path: `/customers`, Component: guard("customers.list", <Customers />) },
  { path: "/customers/customer-detail/:customerId", Component: guard("customers.view", <CustomerDetailPage />) },
  { path: `/tag`, Component: guard("tags.list", <TagManagement />) },
  { path: `/apply-tags`, Component: guard("customers.update", <ApplyTagsPage />) },
  { path: `/help`, Component: <Help /> },

  // Order Route Start
  { path: `/orders`, Component: guard("orders.list", <Orders />) },
  { path: `/orders/:id`, Component: guard("orders.view", <ViewOrder />) },

  // Product Route Start
  { path: `/products`, Component: guard("items.list", <Products />) },
  { path: "/product/create", Component: guard("items.create", <CreateProduct />) },
  { path: "/product/edit/:id", Component: guard("items.update", <CreateProduct />) },

  // Variant Route Start
  { path: `/variants`, Component: guard("items.list", <Variants />) },

  // Stock Route Start
  { path: `/stocks`, Component: guard("stock.list", <Stocks />) },
  { path: "/store/view-inventory-log/:id", Component: guard("stock.view", <InventoryLog />) },
  { path: "/store/view-variants-sales/:id", Component: guard("stock.view", <VariantSalesHistory />) },

  { path: `/collections`, Component: guard("collections.list", <Collections />) },
  { path: `/sub-collections`, Component: guard("sub_collections.list", <SubCollections />) },
  { path: `/stocks`, Component: <Stocks /> },
  { path: "/store/view-inventory-log/:id", Component: <InventoryLog /> },
  { path: "/store/view-variants-sales/:id", Component: <VariantSalesHistory /> },
  { path: `/transfer`, Component: <StockTransfers /> },
  { path: `/collections`, Component: <Collections /> },

  { path: `/sub-collections`, Component: <SubCollections /> },

  // Store Route Start
  { path: `/stores`, Component: guard("stores.list", <Store />) },
  { path: `/delivery-zone-requests`, Component: guard("stores.list", <DeliveryZoneRequests />) },
  { path: `/store`, Component: <Store /> }, // store-user "My Store" — no permission gate
  { path: "/store/product/:id", Component: guard("items.view", <ProductDetails />) },
  { path: `/store/:storeName/:id`, Component: guard("stores.view", <ViewStore />) },
  { path: `/store/revenue/:id`, Component: guard("stores.view", <StoreRevenue />) },

  // Brand Route Start
  { path: `/brands`, Component: guard("brands.list", <Brands />) },

  // Report Route Start
  { path: `/reports`, Component: guard("dashboard.view", <Reports />) },
  { path: `/reports/gp`, Component: <GPReports /> },

  // Content Route Start
  { path: `/banner`, Component: guard("content.list", <ContentManagement />) },
  { path: `/blog`, Component: guard("blogs.list", <Blog />) },
  { path: `/blog-create`, Component: guard("blogs.create", <BlogCreate />) },
  { path: `/blog-edit/:id`, Component: guard("blogs.update", <BlogEdit />) },
  { path: `/blog-dashboard`, Component: guard("blogs.list", <BlogDashboard />) },
  { path: `/blog-detail/:id`, Component: guard("blogs.view", <BlogDetail />) },
  { path: `/blog-categories`, Component: guard("blog_categories.list", <CategoryManagement />) },
  { path: `/blog-comments/pending`, Component: guard("blogs.list", <PendingComments />) },
  { path: `/app-versions`, Component: guard("content.list", <AppVersionManager />) },

  // SEO Route Start
  {
    path: `/settings/seo/static-pages`,
    Component: guard("seo_pages.list", <SeoStaticPages />),
  },

  // Role management Route Start
  { path: `/role-management`, Component: guard("roles.list", <RoleManagement />) },
  { path: `/role-management/create`, Component: guard("roles.create", <RoleForm />) },
  { path: `/role-management/edit/:id`, Component: guard("roles.update", <RoleForm />) },

  // Employees (RBAC admin users) Route Start
  { path: `/employees`, Component: guard("employees.list", <Employees />) },

  // Coupon Route Start
  { path: `/coupons`, Component: guard("coupons.list", <Coupons />) },
  { path: `/coupons/usage`, Component: guard("coupons.list", <CouponUsageAnalytics />) },

  // Loyalty Route Start
  { path: `/loyalty-setting`, Component: guard("loyalty.update", <LoyaltySettings />) },
  { path: `/loyalty`, Component: guard("loyalty.list", <LoyaltyTable />) },
  { path: `/product-boost`, Component: guard("boost.list", <BoostCampaignManager />) },
  { path: `/product-boost/:campaignId`, Component: guard("boost.view", <CampaignDetailsPage />) },
  { path: `/loyalty-history/:userId`, Component: guard("loyalty.view", <LoyaltyHistoryPage />) },

  { path: `/special/create`, Component: guard("items.create", <CreateSpecial />) },
  { path: `/special/edit/:id`, Component: guard("items.update", <CreateSpecial />) },
  { path: `/special`, Component: guard("items.list", <SpecialTable />) },

  // Email Marketing Route
  { path: `/email-marketing`, Component: guard("mailchimp.list", <EmailMarketingDashboard />) },
  { path: `/notice`, Component: guard("notices.list", <Notice />) },

  // Activity Log
  { path: `/activity-log`, Component: <ActivityLog /> },
  { path: `/delivery-partners`, Component: <DeliveryPartners /> },

  { path: `/business`, Component: guard("b2b.list", <Business />) },
  { path: `/business/landing-content`, Component: guard("b2b.list", <LandingContentManager />) },
  { path: `/business/address`, Component: guard("b2b.approve", <B2BAddressApproval />) },

  { path: `/reward-settings`, Component: <RewardSettingsTable />},
   { path: `/reward`, Component: <CustomerRewardsTable />},
  // Inventory Management Routes (feature/inventory_management)
  { path: `/inventory/stores`, Component: guard("stock.list", <StoreManagement />) },
  { path: `/inventory/stores/create`, Component: guard("stock.create", <StoreForm />) },
  { path: `/inventory/stores/edit/:id`, Component: guard("stock.update", <StoreForm />) },
  { path: `/inventory/stores/:id`, Component: guard("stock.view", <InventoryStoreDetails />) },
  { path: `/inventory/suppliers`, Component: guard("stock.list", <SupplierManagement />) },
  { path: `/inventory/suppliers/add`, Component: guard("stock.create", <SupplierForm />) },
  { path: `/inventory/suppliers/edit/:id`, Component: guard("stock.update", <SupplierForm />) },
  { path: `/inventory/suppliers/:id`, Component: guard("stock.view", <SupplierDetails />) },
  { path: `/inventory/purchase-orders`, Component: guard("stock.list", <PurchaseOrders />) },
  { path: `/inventory/purchase-orders/create`, Component: guard("stock.create", <PurchaseOrderForm />) },
  { path: `/inventory/purchase-orders/edit/:id`, Component: guard("stock.update", <PurchaseOrderForm />) },
  { path: `/inventory/purchase-orders/:id`, Component: guard("stock.view", <PurchaseOrderDetails />) },
  { path: `/inventory/purchase-orders/receive/:id`, Component: guard("stock.update", <StockReceiptForm />) },
  { path: `/inventory/returns-to-supplier`, Component: guard("stock.list", <ReturnToSupplier />) },
  { path: `/inventory/returns-to-supplier/create`, Component: guard("stock.create", <ReturnToSupplierForm />) },
  { path: `/inventory/returns-to-supplier/edit/:id`, Component: guard("stock.update", <ReturnToSupplierForm />) },
  { path: `/inventory/returns-to-supplier/:id`, Component: guard("stock.view", <ReturnToSupplierDetails />) },
  { path: `/inventory/stocktakes`, Component: guard("stock.list", <Stocktake />) },
  { path: `/inventory/stocktakes/create`, Component: guard("stock.create", <StocktakeForm />) },
  { path: `/inventory/stocktakes/session/:id`, Component: guard("stock.update", <StocktakeSession />) },
  { path: `/inventory/stocktakes/:id`, Component: guard("stock.view", <StocktakeDetails />) },
  { path: `/inventory/bulk-upload`, Component: guard("stock.create", <BulkUpload />) },
  { path: `/inventory/adjustments`, Component: guard("stock.adjust", <StockAdjustments />) },
  { path: `/inventory/movements`, Component: guard("stock.view", <MovementLog />) },
  { path: `/inventory/reports`, Component: guard("reports.list", <InventoryReporting />) },
  // Business Settings Routes
  { path: `/policies/faq`, Component: <FAQManagement /> },
  { path: `/policies/return-policy`, Component: <ReturnPolicy /> },
  { path: `/policies/privacy-policy`, Component: <PrivacyPolicy /> },
  { path: `/policies/terms-and-conditions`, Component: <TermsAndConditions /> },
  { path: `/policies/about-us`, Component: <AboutUs /> },
  { path: `/policies/contact-us`, Component: <ContactUsEditor /> },
  { path: `/policies/announcements`, Component: <AnnouncementManagement /> },

  { path: `/group-tags`, Component: <GroupTags /> },

  { path: `/flash-deals`, Component: <FlashDeal /> },
  { path: `/flash-deals/create`, Component: <FlashDealCreate /> },
  { path: `/flash-deals/view/:id`, Component: <ViewFlashDeal /> },
  { path: `/flash-deals/edit/:id`, Component: <FlashDealCreate /> },

  { path: "/", Component: <Dashboard /> },
  { path: `*`, Component: <ErrorPage4 /> },
];

export { routes };
